"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerInputFactory = void 0;
const PlayerInputTypes_1 = require("../PlayerInputTypes");
class PlayerInputFactory {
    getComponentName(inputType) {
        switch (inputType) {
            case PlayerInputTypes_1.PlayerInputTypes.AND_OPTIONS:
                return 'and-options';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_CARD:
                return 'select-card';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_HOW_TO_PAY_FOR_PROJECT_CARD:
                return 'select-how-to-pay-for-project-card';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_INITIAL_CARDS:
                return 'select-initial-cards';
            case PlayerInputTypes_1.PlayerInputTypes.OR_OPTIONS:
                return 'or-options';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_OPTION:
                return 'select-option';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_HOW_TO_PAY:
                return 'select-how-to-pay';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_SPACE:
                return 'select-space';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_PLAYER:
                return 'select-player';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_AMOUNT:
                return 'select-amount';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_DELEGATE:
                return 'select-party-player';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_PARTY_TO_SEND_DELEGATE:
                return 'select-party-to-send-delegate';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_COLONY:
                return 'select-colony';
            case PlayerInputTypes_1.PlayerInputTypes.SELECT_PRODUCTION_TO_LOSE:
                return 'select-production-to-lose';
            case PlayerInputTypes_1.PlayerInputTypes.SHIFT_ARES_GLOBAL_PARAMETERS:
                return 'shift-ares-global-parameters';
            default:
                throw 'Unsupported input type: ' + inputType;
        }
    }
    getPlayerInput(createElement, players, player, playerinput, onsave, showsave, showtitle) {
        return createElement(this.getComponentName(playerinput.inputType), {
            attrs: {
                player, players, playerinput, showsave, showtitle, onsave,
            },
        });
    }
}
exports.PlayerInputFactory = PlayerInputFactory;
//# sourceMappingURL=PlayerInputFactory.js.map